import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api, authToken } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      authToken.set(data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sand px-5">
      <form onSubmit={submit} data-testid="admin-login-form"
        className="w-full max-w-sm rounded-3xl border border-black/5 bg-white p-8 shadow-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink text-white"><Lock size={20} /></span>
          <h1 className="mt-4 text-2xl">Owner Portal</h1>
          <p className="mt-1 text-sm text-taupe">Sign in to manage your portfolio</p>
        </div>
        <Input data-testid="admin-email" type="email" placeholder="Email" value={email}
          onChange={(e) => setEmail(e.target.value)} className="mb-3 rounded-2xl border-black/10" />
        <Input data-testid="admin-password" type="password" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)} className="mb-4 rounded-2xl border-black/10" />
        <Button data-testid="admin-login-btn" type="submit" disabled={loading}
          className="h-12 w-full rounded-full btn-ink">{loading ? "Signing in…" : "Sign in"}</Button>
      </form>
    </div>
  );
}
